// Auto generated file, do not manually modify!
// com.hotpads.idverification.client.identity.enums.IdentificationStatusType

export enum IdentificationStatusType {
  CURRENTLY_IDENTIFIED = 'CURRENTLY_IDENTIFIED',
  FROZEN_CREDIT_FILE = 'FROZEN_CREDIT_FILE',
  LOCKED_OUT = 'LOCKED_OUT',
  NOT_IDENTIFIED = 'NOT_IDENTIFIED',
  PREVIOUSLY_IDENTIFIED = 'PREVIOUSLY_IDENTIFIED',
  REAUTHENTICATING = 'REAUTHENTICATING',
  USER_NOT_FOUND_LOCKED_OUT = 'USER_NOT_FOUND_LOCKED_OUT',
}

export const IdentificationStatusType_values = [
  IdentificationStatusType.CURRENTLY_IDENTIFIED,
  IdentificationStatusType.FROZEN_CREDIT_FILE,
  IdentificationStatusType.LOCKED_OUT,
  IdentificationStatusType.NOT_IDENTIFIED,
  IdentificationStatusType.PREVIOUSLY_IDENTIFIED,
  IdentificationStatusType.REAUTHENTICATING,
  IdentificationStatusType.USER_NOT_FOUND_LOCKED_OUT,
] as const;
